import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Element } from "react-scroll";
import { faMapLocation, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BackgroundEffects from "../../UI/BackgroundEffects/BackgroundEffects";
import {
  experience,
  firstExperince,
} from "../../../assets/text/ExperienceText";
import classes from "./Experience.module.css";

const allExperiences = [...experience, firstExperince];

const Experience = () => {
  const sectionRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });

  // Heading fades in with parallax
  const headingY = useTransform(scrollYProgress, [0, 0.3], [40, 0]);
  const headingOpacity = useTransform(scrollYProgress, [0, 0.25], [0, 1]);

  return (
    <Element name="Experience" className={classes.Experience} ref={sectionRef}>
      <BackgroundEffects variant="experience" />
      <motion.div
        className={classes.Heading}
      >
        <h1>Experience</h1>
        <p>My Career Journey</p>
      </motion.div>

      <div className={classes.Timeline}>
        <div className={classes.TimelineLine}></div>

        {allExperiences.map((exp, index) => (
          <motion.div
            key={exp.date}
            className={classes.TimelineItem}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className={classes.Dot}></div>
            <div className={classes.Card}>
              <h3 className={classes.Role}>{exp.role}</h3>
              <div className={classes.Meta}>
                <span className={classes.Company}>
                  <FontAwesomeIcon icon={faMapLocation} />
                  {exp.company}
                </span>
                <span className={classes.Date}>
                  <FontAwesomeIcon icon={faCalendar} />
                  {exp.date}
                </span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </Element>
  );
};

export default Experience;
